export default __webpack_public_path__ + "static/media/slider_1-xs@1x.6eb4d387.webp";